import { setElementHtml } from '@local_modules/generic/dom/set-element-html.js'
import { generateRandomString } from '@local_modules/generic/text/generate-random-string/index.js'
import { fillString } from '@local_modules/generic/string-template.js'

import { checkPageRestriction } from '../../../helpers/restrictions/check-page-restriction.js'
import { applyHtmlRestrictions } from '../../../helpers/restrictions/apply-html-restrictions.js'

import htmlTemplateIndex from './index.html'
import { showTableCurrencies } from './show-table.js'

import { loadCurrencies } from '../../../helpers/app-data-loaders/load-currencies.js'

/**
 *
 * @returns
 */
export async function showPageCurrenciesPG (params) {
  console.log('showPageCurrenciesPG')

  const { containerElementId, browserAppUser, browserAppAccount } = params

  if (!checkPageRestriction({ browserAppUser, browserAppAccount, allowPublic: true })) return

  // Prepare the html
  let htmlIndex = htmlTemplateIndex
  htmlIndex = applyHtmlRestrictions(htmlIndex, { browserAppAccount, browserAppUser })
  const elementId = 'i' + generateRandomString()
  htmlIndex = fillString(htmlIndex, { elementId })

  // Inject in the page
  setElementHtml(containerElementId, htmlIndex)

  document.title = ['Chart of Accounts:', browserAppAccount.data.appAccount.name].join(' ')

  // Set full height
  document.getElementById(containerElementId)?.classList.add('position-absolute')
  document.getElementById(containerElementId)?.classList.add('top-to-bottom')

  document.title = ['Currencies:', browserAppAccount.data.appAccount.name].join(' ')

  const currencyResponse = await loadCurrencies(browserAppAccount.data.appAccount.id)

  showTableCurrencies({
    currencyResponse,
    browserAppAccount
  })
}
